module.exports = __webpack_public_path__ + "static/media/heartPost.10564651.jpg";